import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../hooks";


const PrivateRoutes = () => {
  const token = useAppSelector((state) => state.user.token);
  const isSuspendNonPay = useAppSelector((state) => state.isSuspendNonPay?.isSuspendNonPay) || localStorage?.getItem("suspendnonpay");
  const isVacationPause = useAppSelector((state) => state.isVacationPause?.isVacationPause) || localStorage?.getItem("vacationPause");
  const logoutClickedValue = useAppSelector(
    (state) => state?.user?.logoutClickedValue
  );
  const userStatus = useAppSelector(
    (state) => state?.user?.data?.currentStatus
  );
  const { pathname, search } = useLocation();

  function isMobileDevice() {
    const userAgent = navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  }
  
  if (logoutClickedValue) {
    localStorage.removeItem("redirectPath");
    localStorage.removeItem("redirectPathSuspendnonpay");
    localStorage.removeItem("redirectPathVacationpause");
    localStorage.removeItem("isSuspendNonpay");
    localStorage.removeItem("isVacationPause");
  } else if(process.env.REACT_APP_DEEPLINKING_BLOCK_MOBILE_AGENTS === "true" && isMobileDevice()) {
    // For Mobile device - Deeplinking is removed with Mobile device
    localStorage.removeItem("redirectPath");
  } else {
    if(pathname?.includes("/update-plan") || pathname?.includes("/shop-exp")|| pathname?.includes("/shop-review-order") || pathname?.includes("/change-plan-failed") || pathname?.includes("plan-details?orderNumber")
    || pathname?.includes("/migration-appointment") || pathname?.includes("/migration-review-order") ||
    pathname?.includes("/router-appointment")) {
      localStorage?.setItem("redirectPath", '/account-settings/plan-details');
       if(userStatus && userStatus?.toUpperCase() !=="ACTIVE") {      
        return <Navigate to="/account-settings/plan-details" />
      }
    }else if(pathname?.includes("/error") || pathname?.includes("/network-info") || pathname?.includes("/help-and-support")){
      localStorage?.setItem("redirectPath", '/home');      
    }else if(isSuspendNonPay){
      localStorage?.setItem("redirectPathSuspendnonpay", '/my-bills/view-payments?suspendnonpay');
    }else if(isVacationPause){
      localStorage?.setItem("redirectPathVacationpause", '/pause-service?vacationPause');
    }
    else if(!localStorage?.getItem("redirectPath")){
      localStorage?.setItem("redirectPath", pathname + search);
    }
  }

  return token || localStorage?.getItem("token") ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoutes;
